import { render } from "./adWrite.vue?vue&type=template&id=6141bc22&scoped=true&ts=true"
import script from "./adWrite.vue?vue&type=script&lang=ts&config=true"
export * from "./adWrite.vue?vue&type=script&lang=ts&config=true"

import "./adWrite.vue?vue&type=style&index=0&id=6141bc22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6141bc22"]])

export default __exports__